import * as React from 'react';

/**
 * Input (CC3): the landing flat field - white/90, one hairline, 14px radius,
 * 44px tall, teal border plus soft ring on focus. All styling lives in
 * `.lnr-field` (src/index.css) so dark mode and page overrides work through
 * tokens instead of inline style mutation.
 */
export function Input({ className = '', ...props }: React.InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={`lnr-field ${className}`.trim()} />;
}

export function Label({ children, htmlFor }: { children: React.ReactNode; htmlFor?: string }) {
  return (
    <label htmlFor={htmlFor} className="lnr-label">
      {children}
    </label>
  );
}
